import React from 'react';
import {FormattedMessage, IntlShape} from 'react-intl';

export default class LoggedOutMessage extends React.Component {
    getLoginUrl() {
        return window.config['app-url'] + '/login-only';
    }

    render() {
        return (
            <div className="loggedOutMessage">
                <FormattedMessage defaultMessage="Logged out" id="panel.loggedOut.message" /><br />
                <a href={this.getLoginUrl()} target="_blank">
                    <FormattedMessage defaultMessage="Log In" id="signupButton.signIn" />
                </a>
            </div>
        );
    }
}
